// extracted by mini-css-extract-plugin
export default {"tabLinkWrapper":"TabsNavigation_tabLinkWrapper__q0Oas","tabLink":"TabsNavigation_tabLink__0Ocyo","bigTab":"TabsNavigation_bigTab__vd+dJ"};